module.exports = __webpack_public_path__ + "static/media/hot_bg.0ad142c1.png";